import { useCallback } from 'react';
import { DEFAULT_LANGUAGE } from 'tradera/lang/constants.mjs';
import { useAppSelector } from 'tradera/state/hooks';
import { localizedDayjs } from 'tradera/utils/date';

export const useDayJs = () => {
    const preferredLanguageCodeIso2 = useAppSelector(
        (state) => state.language.preferred?.languageCodeIso2
    );
    const localizedDayjsCallback = useCallback(
        (...args: Parameters<ReturnType<typeof localizedDayjs>>) =>
            localizedDayjs(preferredLanguageCodeIso2 || DEFAULT_LANGUAGE)(
                ...args
            ),
        [preferredLanguageCodeIso2]
    );
    return localizedDayjsCallback;
};
